var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bar-chart',{attrs:{"chart-id":_vm.chartId,"width":_vm.width,"height":_vm.height,"css-classes":_vm.cssClasses,"styles":_vm.styles,"plugins":_vm.plugins}})
}
var staticRenderFns = []

export { render, staticRenderFns }